const DOCUMENT_FILE_TYPES = {
  doc: {
    extension: 'doc',
    mimeType: 'application/msword',
  },
  docx: {
    extension: 'docx',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  ppt: {
    extension: 'ppt',
    mimeType: 'application/vnd.ms-powerpoint',
  },
  pptx: {
    extension: 'pptx',
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  xlsm: {
    extension: 'xlsm',
    mimeType: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  },
  xlsx: {
    extension: 'xlsx',
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
};

const getFileExtension = (filename = '') => {
  const fileParts = filename.toLowerCase().split('.');
  return fileParts.length > 1 ? fileParts[fileParts.length - 1] : '';
};

const removeFileExtension = (filename = '') => {
  return filename.replace(/\.[^/.]+$/, '');
};

export const getDocumentFileType = ({ template, serverFilename, contentType }) => {
  const templateFilename = template?.filename || template?.name || '';
  const templateExtension = getFileExtension(templateFilename);
  const serverExtension = getFileExtension(serverFilename);
  const knownExtension = [serverExtension, templateExtension].find((extension) => DOCUMENT_FILE_TYPES[extension]);

  if (knownExtension) {
    return DOCUMENT_FILE_TYPES[knownExtension];
  }

  if (contentType?.includes('wordprocessingml.document')) {
    return DOCUMENT_FILE_TYPES.docx;
  }

  if (contentType?.includes('application/msword')) {
    return DOCUMENT_FILE_TYPES.doc;
  }

  if (contentType?.includes('presentationml.presentation')) {
    return DOCUMENT_FILE_TYPES.pptx;
  }

  if (contentType?.includes('application/vnd.ms-powerpoint')) {
    return DOCUMENT_FILE_TYPES.ppt;
  }

  if (contentType?.includes('macroenabled')) {
    return DOCUMENT_FILE_TYPES.xlsm;
  }

  return DOCUMENT_FILE_TYPES.xlsx;
};

export const getDownloadFilename = ({ template, serverFilename, extension }) => {
  const preferredName = serverFilename || template?.filename || template?.name || 'generated-template';
  const baseName = removeFileExtension(preferredName);
  return `${baseName}.${extension}`;
};
